<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import type { NavItem, SharedData } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import CardMenuButton from './CardMenuButton.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { computed } from 'vue';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        items: NavItem[];
    }>();

    const { hasPermission } = usePermissions();

    const navItems = computed(() => {
        return props.items.filter(
            (item) => !item.permissionLevel || hasPermission(item.permissionLevel as Permission),
        );
    });

    const page = usePage<SharedData>();
</script>

<template>
    <div
        data-slot="card-menu"
        :class="
            cn('flex flex-row flex-wrap items-center gap-4 sm:shrink-0 sm:flex-nowrap', props.class)
        "
    >
        <CardMenuButton
            v-for="item in navItems"
            :key="item.title"
            :href="item.href"
            :is-active="item.href === page.props.ziggy.location"
        >
            {{ $t(item.title) }}
        </CardMenuButton>
    </div>
</template>
